var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.46 54.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a734d2b4-fa82-4459-ad7b-36dc94bc064d",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f67da1b1-ecfd-4310-b9ec-3723d419f177",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11,54.69,8.28,9c0-2.36,1.41-2.36,1.87-2.36h.16c.46,0,1.87,0,1.87,2.36l2.17,45.66h6.11L18.3,9.5C18.3,4,14.91,0,10.24,0h0C5.55,0,2.16,4,2.16,9.5L0,54.69Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSpinner);
export default __webpack_public_path__ + "static/media/logoSpinner.1c656108228d6fc6694e079ba9d6debf.svg";
export { ForwardRef as ReactComponent };